import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { EyeOffSvg } from './svgs';

export const IconEyeOff: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={EyeOffSvg} viewBox="0 0 24 24" {...props} />;
};
